export default __webpack_public_path__ + "img/8a5931a41799ff280b23468096965d13.png";